import { render, staticRenderFns } from "./27.vue?vue&type=template&id=c5ba4d38&scoped=true&"
var script = {}
import style0 from "./27.vue?vue&type=style&index=0&id=c5ba4d38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ba4d38",
  null
  
)

export default component.exports